<template>
<div id="modal-shipping-rate" class="modal modal-right fade ">
    <div class="modal-dialog modal-lg ">
        <div class="modal-content" ref="section">
            <div class="modal-header bg-slate-800">
                <h5 class="modal-title">{{$t('Shipping Rate Calculator')}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-body">
                <div class="card shadow-sm">
                    <div class="card-header bg-light py-2">
                        <h6 class="card-title">{{$t('Find your carrier')}}</h6>
                    </div>

                    <div class="card-body">
                        <!-- <form action="#" @submit="checkForm"> -->
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <thai-address-input :placeholder="$t('Ship From...')" type="search" v-model="addressOrigin" input-class="form-control" @selected="onSuggestClickOrigin" @input="handleInputOrigin">
                                    </thai-address-input>
                                    <!-- <span class="help-block">กรอกอย่างใดอย่างหนึ่ง ตำบล, อำเภอ, จังหวัด หรือ รหัสไปรษณีย์</span> -->
                                    <label v-if="!$v.addressOrigin.required && submitStatus" class="validation-invalid-label">{{$t("Please enter address origin")}}</label>
                                    <label v-if="!$v.addressOrigin.minLength" class="validation-invalid-label">{{$t(`address origin must have at least {num} letters.`) | replaceText($v.addressOrigin.$params.minLength.min)}}</label>
                                </div>

                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <thai-address-input type="search" :placeholder="$t('Ship To...')" v-model="addressDestination" input-class="form-control" @selected="onSuggestClickDestination" @input="handleInputDestination">
                                    </thai-address-input>
                                    <label v-if="!$v.addressDestination.required && submitStatus" class="validation-invalid-label">{{$t("Please enter address destination")}}</label>
                                    <label v-if="!$v.addressDestination.minLength" class="validation-invalid-label">{{$t(`address destination must have at least {num} letters.`) | replaceText($v.addressDestination.$params.minLength.min)}}</label>
                                </div>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <input type="number" v-model="parcelWeight" class="form-control" :placeholder="$t('Parcel Weigth(G)...')">
                                    <label v-if="!$v.parcelWeight.required && submitStatus" class="validation-invalid-label">{{$t("Please enter parcel weight")}}</label>
                                </div>
                            </div>
                        </div>

                        <div class="text-right">
                            <ladda :text="$t('Check Rate')" :btnClass="'btn btn-primary'" @click="checkRate" :loading="loadingTable" icon="<i class='far fa-search'></i>"></ladda>
                        </div>
                        <!-- </form> -->
                    </div>
                </div>

                <div v-if="!checkRateStatus" class="text-center p-5 bg-white">
                    <div class="text-blue-alpha mb-3">
                        <i class="fa-shipping-fast fas fa-10x"></i>
                    </div>
                    <div class="text-grey-300">
                        {{$t('You can check shipping rates for all carriers.')}}
                    </div>
                </div>

                <div v-show="checkRateStatus">
                    <div class="table-responsive  mt-0 data-nowrap  overflow-auto">
                        <vuetable :class="['datatable-scroll']" :no-data-template="$t('No Data Available')" :data-manager="dataManager" :api-mode="false" :fields="tableFields" ref="vuetable" @vuetable:pagination-data="onPaginationData">
                            <template slot="image" slot-scope="props">
                                <div class="d-flex align-items-center">
                                    <div class="mr-3">
                                        <img v-if="props.rowData.integration" class="ship-icon40" :src="props.rowData.integration.integration_type.logo" alt="">
                                    </div>
                                    <div>
                                        <div><a href="#" class="text-default font-weight-semibold letter-icon-title">{{props.rowData.integration.integration_type.name}}</a></div>
                                        <div v-if="props.rowData.minPrice" class="badge bg-success font-size-sm mr-1">{{$t('Cheapost')}}</div>
                                        <div v-if="props.rowData.minDay" class="badge bg-success font-size-sm mr-1">{{$t('Fastest')}}</div>
                                    </div>
                                </div>
                            </template>

                            <template slot="delivery_time" slot-scope="props">
                                {{props.rowData.integration.integration_type.delivery_time | replaceDay($t('day'))}}
                            </template>

                            <template slot="pickup_locations" slot-scope="props">
                                <div v-for="(item,index) in props.rowData.integration.integration_type.pickup_locations" :key="index">
                                    <template v-if="item =='PICKUP'"><i class="fas fa-shipping-fast mr-1 mt-1 mb-1"></i>{{$t('Pick up')}}</template>
                                    <template v-if="item =='DROPOFF'"><i class="fas fa-hand-holding-box mr-1 mt-1 mb-1"></i>{{$t('Drop off')}}</template>
                                </div>
                            </template>

                            <template slot="carrier_type" slot-scope="props">
                                <div v-for="(item,index) in props.rowData.integration.integration_type.carrier_type" :key="index">
                                    <template v-if="item =='STANDARD'">{{$t('send standard')}}</template>
                                    <template v-else>{{$t(item)}}</template>
                                </div>
                            </template>

                        </vuetable>
                    </div>
                    <div class="datatable-footer border-0">
                        <vuetable-pagination-info class="dataTables_info" ref="paginationInfo" no-data-template="" :info-template="$t('Displaying {from} to {to} of {total} items')"></vuetable-pagination-info>
                        <div class="dataTables_paginate paging_simple_numbers mb-0">
                            <vuetable-pagination ref="pagination" pagination-path="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import numeral from "numeral"
import Vuetable from "vuetable-2"
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import RateTableField from './assets/rateTableField';
import Api from '@/services/endpoint/tenant.service';
import {
    required,
    minLength
} from "vuelidate/lib/validators";
import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
import Ladda from '@/plugins/Ladda.vue'

export default {
    components: {
        numeral,
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        PlaceholderContent,
        Ladda
    },
    data() {
        return {
            loadingTable: false,
            checkRateStatus: false,
            parcelWeight: '',
            tableFields: RateTableField,

            addressOrigin: '',
            addressOriginObj: {},
            addressDestination: '',
            addressDestinationObj: {},
            fetchDataTableData: [],
            perPage: 10,
            mode: 'input',
            loading: false,
            submitStatus: false,

            search: '',
            searchResult: '',
            carriers: [],
            rateCalculate: []
        }
    },
    methods: {
        onPaginationData(tablePagination) {
            this.$refs.paginationInfo.setPaginationData(tablePagination);
            this.$refs.pagination.setPaginationData(tablePagination);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        dataManager(sortOrder, pagination) {
            let local = this.fetchDataTableData;
            local = _.orderBy(local, 'code', 'desc');

            pagination = this.$refs.vuetable.makePagination(
                local.length,
                this.perPage
            );

            let from = pagination.from - 1;
            let to = from + this.perPage;

            return {
                pagination: pagination,
                data: local.slice(from, to)
            };
        },
        checkRate() {
            this.submitStatus = true;
            this.loadingTable = true;
            this.$v.parcelWeight.$touch();
            this.$v.addressOrigin.$touch();
            this.$v.addressDestination.$touch();
            if (this.$v.parcelWeight.$error || this.$v.addressOrigin.$error || this.$v.addressDestination.$error) {
                this.loadingTable = false;
                return;
            }
            this.shipmentEstimate();
        },
        onSuggestClickOrigin(suggest) {
            this.addressOriginObj = suggest;
            this.addressOrigin = this.textSuggest(suggest);
        },
        onSuggestClickDestination(suggest) {
            this.addressDestinationObj = suggest;
            this.addressDestination = this.textSuggest(suggest);
        },
        handleInputOrigin(key) {
            let inputValue = key.split(",");
            if (inputValue.length > 1 && key.length > 5) {
                this.addressOrigin = '';
            }
        },
        handleInputDestination(key) {
            let inputValue = key.split(",");
            if (inputValue.length > 1 && key.length > 5) {
                this.addressDestination = '';
            }
        },
        textSuggest(suggest) {
            return `${suggest.subdistrict}, ${suggest.district}, ${suggest.province}, ${suggest.postalCode}`;
        },
        async shipmentEstimate() {
            await Api.Shipment.postShipmentEstimate({
                "carrier": 'ALL',
                "weight": this.parcelWeight,
                "sender": {
                    "subdistrict": this.addressOriginObj.subdistrict,
                    "city": this.addressOriginObj.district,
                    "state": this.addressOriginObj.province,
                    "postcode": this.addressOriginObj.postalCode
                },
                "recipient": {
                    "subdistrict": this.addressDestinationObj.subdistrict,
                    "city": this.addressDestinationObj.district,
                    "state": this.addressDestinationObj.province,
                    "postcode": this.addressDestinationObj.postalCode
                }
            }).then(async dataEstimate => {
                if (!dataEstimate.data.status) {
                    this.checkRateStatus = true;
                    this.loadingTable = false;
                    return;
                }

                const dataCarriers = this.carriers.data.data;
                let rateCalculate = [];
                let rateData = [];
                if (dataEstimate.data.data) {
                    rateCalculate = dataEstimate.data.data.rate_calculate;
                    for (let [idx, rate] of Object.entries(rateCalculate)) {
                        let index = dataCarriers.findIndex(c => c.integration_type.code == rate.code);
                        if (index < 0 || !rate.price) continue;
                        rateCalculate[idx]['integration'] = dataCarriers[index];
                        rateData.push(rateCalculate[idx]);
                    }
                    this.rateCalculate = rateData;
                }
            });

        }
    },
    async mounted() {
        this.carriers = await Api.Integration.getIntegration('?integration_group_id=4');
    },
    watch: {
        fetchDataTableData(nval) {
            this.$refs.vuetable.refresh();
        },
        async rateCalculate(rateCalculate) {
            let minPrice = Math.min.apply(null, rateCalculate.map(rate => rate.price));
            let indexMinPrice = await rateCalculate.findIndex(rate => rate.price == minPrice);
            rateCalculate[indexMinPrice].minPrice = true;

            let minDay = '9-30 day'; //set default
            for await (let rateIntegration of rateCalculate) {
                if (!rateIntegration.integration) continue;
                if (rateIntegration.integration.integration_type.delivery_time < minDay) minDay = rateIntegration.integration.integration_type.delivery_time;
            }

            let idx = 0;
            for await(let rateIntegration of rateCalculate) {
                idx++;
                if (!rateIntegration.integration) continue;
                if(rateIntegration.integration.integration_type.delivery_time == minDay){
                    rateCalculate[idx - 1].minDay = true;
                }
            }

            this.fetchDataTableData = rateCalculate;
            this.checkRateStatus = true;
            this.loadingTable = false;
        }
    },
    filters: {
        replaceText: function (text, value) {
            if(!text) return;
            return text.replace('{num}', value || 0);

        },
        replaceDay: function (text, val) {
            if(!text) return;
            return text.replace('day', val);
        },
    },
    validations: {
        parcelWeight: {
            required
        },
        addressOrigin: {
            required,
            minLength: minLength(3)

        },
        addressDestination: {
            required,
            minLength: minLength(3)
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/ModalShippingRate.vue